import React from 'react';
import { CheckBoxSVG, UploadSVG, ProgressBar, LoadingSVG, ErrorSVG } from './icones';

export const InputFile = function({ percentage, isEmpty, label, type, update, status, href }) {
  return (
    <div className="input-file-container">
      <ProgressBar percentage={percentage}></ProgressBar>
      <span style={{ color: isEmpty ? '#009688' : null }} className="text-of-input-file">{label}</span>
      <span className="image-notification">
        {status === 'complete' && <CheckBoxSVG></CheckBoxSVG>}
        {status === 'empty' && <UploadSVG></UploadSVG>}
        {status === 'loading' && <LoadingSVG></LoadingSVG>}
        {status === 'error' && <ErrorSVG></ErrorSVG>}
      </span>
      <input type={type} onChange={update} />
    </div>
  )
}